export default __webpack_public_path__ + "static/media/img_declaration_bottom_banner.24e79bc9.png";